import React from 'react';
import configData from '../../config.json';
import IFrame from '../../Components/common/IFrame/IFrame';
import TIFOSkeleton from '../../Components/common/Skeletons/TIFOSkeleton';
import { useWindowSize } from '../../utils/hooks';
import { responsiveSizeTIFO } from '../../utils/constants';

export function Tifo() {
  const size = useWindowSize();

  return (
    <IFrame
      src={configData.REACT_APP_TIFO_URL}
      headers={{
        'Content-Security-Policy': `frame-ancestors ${configData.REACT_APP_TIFO_URL}/`
      }}
      width={size.width > responsiveSizeTIFO ? '100%' : '100vw'}
      height={size.width > responsiveSizeTIFO ? 'calc(100vh - 74px)' : 'calc(100vh - 137px)'}
    >
      <TIFOSkeleton />
    </IFrame>
  );
}
